<script setup lang="ts">
import { cn } from '@/lib/utils';
import { ToastViewport, type ToastViewportProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<ToastViewportProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <ToastViewport
    v-bind="delegatedProps"
    :class="
      cn(
        'fixed inset-x-0 top-0 z-[100] mx-auto flex max-h-screen w-fit max-w-max flex-col-reverse p-4 sm:bottom-10 sm:top-auto sm:flex-col',
        props.class
      )
    "
  />
</template>
